<template>
  <div class="services--group">
    <h3
      :id="`servicegroup_${serviceGroup.id}`"
      class="services--group-title">{{serviceGroup.name}}</h3>
    <p class="services--group-description">{{serviceGroup.description}}</p>
    <div class="services--table" :aria-describedby="`servicegroup_${serviceGroup.id}`">
      <ServicesFormGroupRow
        v-for="service in serviceGroup.services"
        :key="service.id"
        :quantity="hasQuantity(service.id)"
        :selected="isSelected(service.id)"
        :service="service"
        @toggleService="toggleService"
        @updateQuantity="updateQuantity" />
    </div>
  </div>
</template>

<script>
import ServicesFormGroupRow from '@/components/ServicesFormGroupRow.vue';

export default {
  components: {
    ServicesFormGroupRow,
  },
  props: {
    selectedServices: {
      type: Array,
      required: true,
    },
    serviceGroup: {
      type: Object,
      required: true,
    },
  },
  inject: ['$validator'],
  computed: {
    services() {
      return this.serviceGroup.services ?? [];
    },
  },
  methods: {
    hasQuantity(serviceId) {
      const foundService = this.selectedServices
        .find(service => service.id === serviceId);
      return foundService
        ? foundService.quantity
        : null;
    },
    isSelected(serviceId) {
      return this.selectedServices.some(service => service.id === serviceId);
    },
    toggleService(serviceId) {
      this.$emit('toggleService', serviceId);
    },
    updateQuantity(servicePayload) {
      this.$emit('updateQuantity', servicePayload);
    },
  },
};
</script>

<style lang="scss">
.services--group {
  padding: 1.23rem 0;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
  }

  &-description {
    font-size: 1.125rem;
    letter-spacing: 0.033rem;
    line-height: 1.75;
  }

  &-title {
    font-size: 1.15rem;
    letter-spacing: -0.02rem;
    margin: 0 0 0.725rem;
  }
}

.services--table {
  border-collapse: collapse;
}
</style>
